import { SESSION_FLAG } from '@/router/routeGuards'

// Shared by Login.vue and MemberArmsEdit.vue - both perform an auto-login immediately after a
// backend call that may issue a quarantine/terms-jail session, and both must land directly on
// that jail's own screen rather than their ordinary post-login destination: none of those
// ordinary destinations are on either jail's whitelist, so letting the router guard catch the
// resulting violation would destroy the just-issued token and bounce back to a login prompt
// instead. Kept as one shared function so the mapping can't drift between callers.
//
// Returns the jail's own route name for a quarantine/terms-jail session flag, or null for ACTIVE
// (or the legacy, pre-migration absent-flag case) - the caller falls back to its own ordinary
// post-login destination in that case.
export function routeNameForSessionFlag (sessionFlag) {
  if (sessionFlag === SESSION_FLAG.IDENTITY_VERIFICATION_REQUIRED || sessionFlag === SESSION_FLAG.MIGRATION_REQUIRED) {
    return 'identityVerification'
  }
  if (sessionFlag === SESSION_FLAG.TERMS_ACKNOWLEDGEMENT_REQUIRED) {
    return 'acceptTerms'
  }
  return null
}
